import { Platform } from "react-native";
let Slider;
if (Platform.OS !== 'web') {
  Slider = require('react-native-slider').default;
} else {
  Slider = require('@react-native-community/slider').default;
}
export default Slider;